import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "xmlns:serif": "http://www.serif.com/",
  width: "100%",
  height: "100%",
  viewBox: "0 0 105 116",
  version: "1.1",
  "xml:space": "preserve",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "star",
      d: "M52.308,116.741l-18.199,-28.012l18.199,-21.221l18.199,21.221l-18.199,28.012Zm-7.44,-57.998l-25.644,29.088l-19.224,0l17.878,-29.088l-17.878,-29.088l19.224,0l25.644,29.088Zm41.95,0l17.878,29.088l-19.224,0l-25.644,-29.088l25.644,-29.088l19.224,0l-17.878,29.088Zm-34.429,-57.998l18.199,28.012l-18.199,21.221l-18.199,-21.221l18.199,-28.012Z",
      style: {"fill":"#392f60"}
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "logostar"}) } }